import { Box } from '@mui/material';

import { Typography, LazyAutocompleteField } from '@occc/ui-design-system';
import {
  mapRawStatesResponseItemToAutocompleteOption,
  mapStatesQueryResponseToRawArray,
  useStatesQuery,
} from '@occc-app/design-system';

import { UnitedState } from './types';

export const LocationInStateConstraint = () => (
  <Box>
    <Typography variant='h6' paragraph>
      State Restrictions
    </Typography>
    <LazyAutocompleteField<UnitedState, UnitedState[]>
      name='inStates.states'
      label='Location Constraint'
      useLazyQuery={useStatesQuery}
      mapQueryResponseToRawArray={mapStatesQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawStatesResponseItemToAutocompleteOption}
      inputProps={{ margin: 'none' }}
      filterSelectedOptions
    />
  </Box>
);
